import {
  BetaScoreTierMapping,
  DataConfidence,
  TierToColorClass,
} from '@/enums'

export function getTierFromScore(score) {
  if (typeof score !== 'number' || Number.isNaN(score)) return null;
  return (
    BetaScoreTierMapping.find(t => score >= t.minRawScore) ||
    BetaScoreTierMapping[BetaScoreTierMapping.length - 1]
  );
}

export function getTierFromBucket(bucket) {
  const b = Number(bucket);
  if (b < 1 || b > 5) return '';
  const m = BetaScoreTierMapping.find(x => x.colorBucket === b);
  return m ? m.tier : '';
}

export function normalizeConfidence(v) {
  const raw = String(v || '').trim().toLowerCase();
  switch (raw) {
    case 'low': return DataConfidence.LOW;
    case 'medium': return DataConfidence.MEDIUM;
    case 'high': return DataConfidence.HIGH;
    default: return '';
  }
}

function normalizeDirectTier(v) {
  const s = String(v || '').trim();
  if (!s) return '';
  const cleaned = s.replace(/\s*tier$/i, '').toLowerCase();
  const m = BetaScoreTierMapping.find(
    x => x.tier && x.tier.toLowerCase() === cleaned
  );
  return m ? m.tier : '';
}

export function resolveTierName(scoreObj) {
  const s = scoreObj || {};
  if (typeof s.score !== 'number' || Number.isNaN(s.score)) return '';
  const fromDirect = normalizeDirectTier(s.tier || s.title);
  if (fromDirect) return fromDirect;
  const fromScore = getTierFromScore(s.score);
  return fromScore?.tier || '';
}

export function getTierColorClass(tierName) {
  return TierToColorClass[tierName] || '';
}

export function resolveRiskLevel(scoreObj) {
  return scoreObj?.riskLevel ?? '';
}
